import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// tools
import AuthenticationService from '../../service/authentication-service';
import ErrorBoundary from '../ErrorBoundary';

const ProtectedRoute = () => {


    if (!AuthenticationService.isLoggedIn()) {
        return (<Navigate to={'/login?redirectReason=auth_required'} replace/>);
    }

    return <ErrorBoundary><Outlet/></ErrorBoundary>;
}

export default ProtectedRoute;